import createIcon from '../../createIcon';

/**
 * @component @name StackedLineChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxOS45ODk4TDkuNSAxMi40Nzk4TDEzLjUgMTYuNDc5OEwyMC41OSA4LjUwOTc3TDIyIDkuOTE5NzdMMTMuNSAxOS40Nzk4TDkuNSAxNS40Nzk4TDMuNSAyMS40ODk4TDIgMTkuOTg5OFpNMy41IDE1LjQ4OThMOS41IDkuNDc5NzZMMTMuNSAxMy40Nzk4TDIyIDMuOTE5NzdMMjAuNTkgMi41MDk3N0wxMy41IDEwLjQ3OThMOS41IDYuNDc5NzdMMiAxMy45ODk4TDMuNSAxNS40ODk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StackedLineChart = createIcon('StackedLineChart', [
  [
    'path',
    {
      d: 'M2 19.9898L9.5 12.4798L13.5 16.4798L20.59 8.50977L22 9.91977L13.5 19.4798L9.5 15.4798L3.5 21.4898L2 19.9898ZM3.5 15.4898L9.5 9.47976L13.5 13.4798L22 3.91977L20.59 2.50977L13.5 10.4798L9.5 6.47977L2 13.9898L3.5 15.4898Z',
      key: 'jvhnjr',
    },
  ],
]);

export default StackedLineChart;
